export const metricsRoute = '/api/v1/metrics';
export enum ProxyUrls {
    GET_SHIFT_BOOKINGS = 'workers/timesheets/shift_bookings',
    DUPLICATE_SHIFT_BOOKING = 'workers/duplicate_shift_booking',
}

export enum FlexAuthUrls {
    GET_USER_BY_TOKEN = 'users/get_by_token',
    REFRESH_USER_TOKEN = 'users/refresh',
}

export const HELP_LINK = 'https://indeedflex.onelink.me/4jvh/workeradhocshiftssupport';

export const enumKeys = <O extends object, K extends keyof O = keyof O>(obj: O): K[] => {
    return Object.keys(obj).filter((k) => Number.isNaN(Number(k))) as K[];
};

export const MAX_ALLOWED_SHIFT_HOURS = 18;
export const MAX_SHIFTS_TO_COPY_FROM = 3;
export const WORKER_PROFILE_TYPE = 'worker';
